export const buildField = (fieldValue, fieldKey) => {
  return {
    name: fieldKey,
    value: fieldValue
  };
};
export const transformObjectToFormFieldsArray = fields => {
  return Object.keys(fields).map(k => buildField(fields[k], k)).filter(k => Boolean(k.value));
};